/*
* Lucky Bastardo — Custom JS
* Broadcast Theme V5.3.0
* author Klemkin
* - Scroll reveal animations
* - Marquee infinite scroll
*/

(function() {

  // ═══ SCROLL REVEAL ═══
  function initScrollReveal() {
    const revealElements = document.querySelectorAll('.lb-reveal');
    if (!revealElements.length) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('lb-visible');
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -40px 0px'
    });

    revealElements.forEach(el => observer.observe(el));
  }

  // ═══ MARQUEE CLONE ═══
  function initMarquee() {
    const tracks = document.querySelectorAll('.lb-marquee-track');
    tracks.forEach(track => {
      if (track.dataset.cloned === 'true') return;
      const children = Array.from(track.children);
      children.forEach(child => {
        const clone = child.cloneNode(true);
        track.appendChild(clone);
      });
      track.dataset.cloned = 'true';
    });
  }

  // ═══ INIT ═══
  function init() {
    initScrollReveal();
    initMarquee();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

})();
